import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import _to_consumable_array from "@swc/helpers/src/_to_consumable_array.mjs";
import { useState } from "react";
import { useAsync } from "react-async";
export function useAsyncWithRequest(args) {
    var wrappedRun = function wrappedRun() {
        for(var _len = arguments.length, runArgs = new Array(_len), _key = 0; _key < _len; _key++){
            runArgs[_key] = arguments[_key];
        }
        setRequest.apply(void 0, _to_consumable_array(runArgs));
        return run.apply(void 0, _to_consumable_array(runArgs));
    };
    var ref = useState(null), request = ref[0], setRequest = ref[1];
    var _ref = useAsync(args), run = _ref.run, rest = _object_without_properties(_ref, [
        "run"
    ]);
    return _object_spread({
        request: request,
        run: wrappedRun
    }, rest);
}
